<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    @close="close"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="类型" prop="type">
        <el-input v-model="form.type"></el-input>
      </el-form-item>

      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item label="ICON" prop="icon">
        <image-upload v-model="form.icon" />
        <!-- <el-input v-model="form.icon"></el-input> -->
      </el-form-item>

      <el-form-item label="介绍" prop="introduction">
        <el-input
          v-model="form.introduction"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 3 }"
        ></el-input>
      </el-form-item>

      <el-form-item label="示例图片" prop="sampleImageUrl">
        <image-upload v-model="form.sampleImageUrl" />
        <!-- <el-input v-model="form.sampleImageUrl"></el-input> -->
      </el-form-item>

      <el-form-item label="背景图" prop="bgImage">
        <image-upload v-model="form.bgImage" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
export default {
  components: { ImageUpload },
  data() {
    return {
      title: "",
      form: {},
      rules: {},
      dialogFormVisible: false,
      loading: false,
    };
  },
  methods: {
    async showEdit(row) {
      if (!row) {
        this.title = "添加";
      } else {
        this.title = "编辑";
        this.form = await this.axios.get("base:/api/admin/appraise-image-type/" + row.id);
      }
      this.dialogFormVisible = true;
    },
    close() {
      this.$refs.formRef.resetFields();
      this.form = {};
      this.dialogFormVisible = false;
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let url;
          if (this.title === "添加") {
            url = "base:/api/admin/appraise-image-type/create";
          } else if (this.title === "编辑") {
            url = "base:/api/admin/appraise-image-type/update";
          }

          const params = {
            ...this.form,
          };
          try {
            await this.axios.form(url, params);
            this.$message.success("保存成功");
            this.$emit("success");
            this.close();
          } catch (e) {
            this.$notify.error({ title: "错误", message: e.message || e });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
